import React, { useEffect, useRef, useState } from 'react'
import style from './index.module.scss'
import {
    CommonObj,
} from '../utils';
import { group_E, group_F } from './constans';
import Card2 from '../components/Card_2';
import { post } from 'common/utils';

const Comp = (props) => {
    const { refreshTick } = props;
    const currScene = useRef(props.sceneInfo);
    const onLoadOver = useRef(props.onLoadOver);
    const [gpEIndex, setgpEIndex] = useState(null);
    const [gpFIndex, setgpFIndex] = useState(null);
    const [tag2Value, setTag2Value] = useState({});

    const queryLock = useRef(null);
    useEffect(() => {
        if (typeof refreshTick === 'symbol') {
            // refresh signal
            const tag_name_list = []
                .concat(
                    ...(
                        group_E.children.map((child) => {
                            const { basic_tag, tag_1, tag_2, tag_3, tag_4 } = child;
                            return [tag_1, tag_2, tag_3, tag_4].map((tag) => basic_tag + tag);
                        })
                    ),
                    ...(
                        group_F.children.map((child) => {
                            const { basic_tag, tag_1, tag_2, tag_3, tag_4 } = child;
                            return [tag_1, tag_2, tag_3, tag_4].map((tag) => basic_tag + tag);
                        })
                    ),
                );
            const trimed_tag_name_list = [...new Set(tag_name_list)];
            const currLock = Symbol();
            queryLock.current = currLock;
            post(process.env.REACT_APP_SERVER_PATH + 'api/data/get_values_before_time', {
                tag_name_list: trimed_tag_name_list,
            })
                .then((retData) => {
                    if (queryLock.current !== currLock) {
                        return;
                    };
                    // console.log(retData);
                    if (retData.data && retData.data.errcode === 0) {
                        setTag2Value(retData.data.results);
                    };
                });
        };
        return () => {
            queryLock.current = Symbol();
        };
    }, [refreshTick]);

    useEffect(() => {
        onLoadOver.current = props.onLoadOver;
    }, [props]);
    useEffect(() => {
        if (!currScene.current) return;
        currScene.current.displayFunc(
            {//Action-2
                num: group_E.children.length,
                cb: (index) => {
                    // console.log(`now E display no.${index}`);
                    setgpEIndex(index);
                },
            },
            {//Action-3
                num: group_F.children.length,
                cb: (index) => {
                    // console.log(`now F display no.${index}`);
                    setgpFIndex(index);
                },
            },
            {//Action-4
                cb: () => {
                    // console.log("E,F消失");
                    setgpEIndex(null);
                    setgpFIndex(null);
                },
            },
            {//over
                cb: () => {
                    // console.log("over");
                    if (typeof onLoadOver.current === 'function') {
                        onLoadOver.current();
                    };
                },
            },
        );
        return () => {
            clearTimeout(CommonObj.mySetTimeout);
        };
    }, []);
    return (
        <div className={style['wrapper']}>
            {
                typeof gpEIndex === 'number' && (
                    <div className="gp_wrapper gpE">
                        <div className="title">{group_E.name}</div>
                        <div className="content">
                            {
                                group_E.children
                                    .map((item, index) => {
                                        const { basic_tag, tag_1, tag_2, tag_3, tag_4, precision_1, precision_2, precision_3 } = item;
                                        const values = [tag_1, tag_2, tag_3, tag_4].map((tag) => tag2Value[basic_tag + tag]);
                                        const precisions = [null, precision_1, precision_2, precision_3].map((v) => typeof v === 'number' ? v : null);
                                        return (
                                            <div style={{ marginTop: index > 0 ? 8 : 0 }} key={index} className={index > gpEIndex ? "card_hide" : ""}>
                                                <Card2 name={item.name} unit={item.unit} values={values} precisions={precisions} />
                                            </div>
                                        );
                                    })
                            }
                        </div>
                    </div>
                )
            }
            {
                typeof gpFIndex === 'number' && (
                    <div className="gp_wrapper gpF">
                        <div className="title">{group_F.name}</div>
                        <div className="content">
                            {
                                group_F.children
                                    .map((item, index) => {
                                        const { basic_tag, tag_1, tag_2, tag_3, tag_4, precision_1, precision_2, precision_3 } = item;
                                        const values = [tag_1, tag_2, tag_3, tag_4].map((tag) => tag2Value[basic_tag + tag]);
                                        const precisions = [null, precision_1, precision_2, precision_3].map((v) => typeof v === 'number' ? v : null);
                                        return (
                                            <div style={{ marginTop: index > 0 ? 8 : 0 }} key={index} className={index > gpFIndex ? "card_hide" : ""}>
                                                <Card2 name={item.name} unit={item.unit} values={values} precisions={precisions} />
                                            </div>
                                        );
                                    })
                            }
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default Comp
